import { createIcon } from '@mote/ui/components/icon'
import { defaultProps } from './defaultProps'

export const ChevronUpIcon = createIcon({
  displayName: 'ChevronUpIcon',
  path: (
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
      d='M15.25 14.25L12 10.75L8.75 14.25'
    />
  ),
  defaultProps: defaultProps
})
